import { useCallback } from 'react'
import { useIntl } from 'react-intl'

export function useIntlLocale() {
  const { formatMessage } = useIntl()

  const t = useCallback(
    (id, placeholder) =>
      placeholder === undefined
        ? formatMessage({ id })
        : formatMessage({ id }).replace(/{placeholder}/, `${placeholder}`),
    [formatMessage],
  )

  return t
}
